import deleteIcon from '../../../assets/icons/new_icon/delete-2.svg';
interface Props {
  leg: any;
  legName: any;
  route: any;
  rateInfo: any;
  transitDays: any;
  handleDeleteLeg?: any;
  isPriceHidden?: boolean;
  indexOfA1: any;
}
const ShipmentATALegsRow = ({
  leg,
  legName,
  route,
  rateInfo,
  transitDays,
  handleDeleteLeg,
  isPriceHidden,
  indexOfA1,
}: Props) => {
  let subtotal =
    parseFloat(rateInfo?.total || 0) - parseFloat(rateInfo?.tax || 0);
  subtotal = parseFloat(subtotal.toFixed(2));

  return (
    <tr>
      <td className='align-middle'>{legName}</td>
      <td className='align-middle'>{`${route?.origin} - ${route?.destination}`}</td>
      <td className='align-middle'>
        {route?.carrier_name} <br />
        {route?.service_name}
      </td>
      {leg?.leg === 'A2' ? (
        <td
          colSpan={4}
          className={'text-center'}
          style={{ verticalAlign: 'middle' }}
        >
          <span
            className={'small-light-text text-center'}
          >{`Est Business Days, Subtotal, Tax and Total are added with L${
            indexOfA1 + 1
          }`}</span>
        </td>
      ) : (
        <>
          <td className='align-middle'>
            {transitDays === 0
              ? 'Same Day'
              : transitDays === -1
              ? 'N/A'
              : transitDays}
          </td>
          <td className='align-middle'>
            ${isPriceHidden ? '-' : subtotal}
          </td>
          <td className='align-middle'>
            ${isPriceHidden ? '-' : rateInfo?.tax}
          </td>
          <td className='align-middle'>
            ${isPriceHidden ? '-' : rateInfo?.total}
          </td>
        </>
      )}
      <td className='align-middle'>
        {handleDeleteLeg && (leg?.leg === 'P' || leg?.leg === 'D') && (
          <img
            alt='delete-icon'
            src={deleteIcon}
            onClick={() => handleDeleteLeg(leg?.leg)}
            className='packageBoxIcon'
            style={{
              backgroundColor: 'rgba(252, 0, 0, 0.10)',
              cursor: 'pointer',
            }}
          />
        )}
      </td>
    </tr>
  );
};

export default ShipmentATALegsRow;
